import { JointEntityShape } from '../Shape/JointEntityShape';
import { Implement } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Implement';
import { JointInterfaceShape } from '../Shape/JointInterfaceShape';
import { RelationshipLink } from '../../BaseShape/RelationshipLink';
import { MDAConstant } from '../../Base/MDAConstant';
import { MDRepository } from '../../../MD/MDRepository';

export class JointImplementLink extends RelationshipLink {
  constructor(opt?: any) {
    super(opt);
    this.set('type', 'mst.JointImplementLink');
    this.attr({
      line: {
        strokeDasharray: '3 5',
        stroke: 'lime',
        targetMarker: { fill: 'white' }
      }
    });
    // 反序列化调用，手工创建的时候不调用
    if (opt) {
      this.setMD(opt?.shape, opt?.model, true);
    }
  }

  changeTarget(source: joint.dia.Element, target: joint.dia.Element) {
    if (target instanceof JointInterfaceShape && source instanceof JointEntityShape) {
      const sourceEntity = source.entity;
      const targetInterface = target.interface;
      let relationship = this.element() as Implement;
      if (relationship === null) {
        relationship = MDRepository.createImplement(null, sourceEntity, targetInterface, false);
      }
      relationship.name = `${sourceEntity.name}_implement_${targetInterface.name}`;
      relationship.displayName = `${sourceEntity.displayName}_实现_${targetInterface.displayName}`;
      relationship.description = relationship.displayName;
      relationship.interface = targetInterface;
      this.setModel(relationship);
      sourceEntity.implements.push(relationship);
      targetInterface.implements.push(relationship);
      return relationship;
    }
    return null;
  }

  get implement(): Implement {
    return this.element() as Implement;
  }

  public shapeType(): string {
    return MDAConstant.Link.ADD_IMPLEMENT;
  }

  /**
   * 检查源和目标类型对当前关系是否有效
   * 实现关系：仅用于实体（源）实现接口（目标）
   * @param sourceType 源类型
   * @param targetType 目标类型
   * @returns 有效返回true
   */
  public checkShapeType(sourceType: string, targetType: string): boolean {
    if (sourceType === MDAConstant.Type.ADD_ENTITY && targetType === MDAConstant.Type.ADD_INTERFACE) {
      return true;
    }
    return false;
  }
}
